module.exports = __webpack_public_path__ + "img/170.678fbf76.jpg";